import { atom } from 'jotai';

import { automationActivateAtom } from '../_graphql/mutationAutomationActivate';
import { automationDeleteAtom } from '../_graphql/mutationAutomationDelete';
import { automationDuplicateAtom } from '../_graphql/mutationAutomationDuplicate';
import { automationPauseAtom } from '../_graphql/mutationAutomationPause';
import { automationTestAtom } from '../_graphql/mutationAutomationTest';
import { automationUpdateAtom } from '../_graphql/mutationAutomationUpdate';
import { automationDetailQueryAtom } from '../_graphql/queryAutomation';
import { automationsRoutes } from '../routes';
import { AutomationDetailsTab } from '../types';

import {
  atomFromRoutePath,
  atomFromQueryString,
} from '~/shared/state/location.state';

// Route Parameters
export const $automationIdFromRoute = atomFromRoutePath(
  automationsRoutes.detail,
);

export const $automationId = atom((get) => {
  const params = get($automationIdFromRoute) as { id?: string } | null;
  return params?.id ? String(params.id) : undefined;
});

// Query String Parameters
export const $tab = atomFromQueryString.string<AutomationDetailsTab>(
  'tab',
  'overview',
);

// Remote Data
export const $remoteAutomation = automationDetailQueryAtom((get) => {
  const id = get($automationId);
  return {
    variables: { id: id ?? '' },
    skip: !id,
  };
});

// Computed Data
export const $automation = atom((get) => {
  const result = get($remoteAutomation);
  return result.data ?? null;
});

export const $isLoading = atom((get) => {
  const result = get($remoteAutomation);
  return result.isLoading ?? false;
});

export const $error = atom((get) => {
  const result = get($remoteAutomation);
  return result.error ?? null;
});

// Actions
export const $updateAutomation = automationUpdateAtom({
  onSuccess: (get) => {
    get($remoteAutomation).refetch?.();
  },
});

export const $activateAutomation = automationActivateAtom({
  onSuccess: (get) => {
    get($remoteAutomation).refetch?.();
  },
});

export const $pauseAutomation = automationPauseAtom({
  onSuccess: (get) => {
    get($remoteAutomation).refetch?.();
  },
});

export const $deleteAutomation = automationDeleteAtom();

export const $duplicateAutomation = automationDuplicateAtom();

export const $testAutomation = automationTestAtom();
